orders-planner-task-editor
  .form-wrap(if="{selected}")
    h6
      span.square(style="background: {this.colorcode}")
      span.text { this.title }
    .form-wrap
      forms-tasks-update(tag-scope="forms_tasks_update")
  script(type="typescript").
    this.mixin('orders.planner.task.editor');
